const repairLog = {
  backbtn: "Atrás",
  title: "CREAR NUEVO REGISTRO DE REPARACION",
  tag: "TAG del Equipo",
  createdby: "Creado por",
  log: "Registro",
  submitbtn: "ENVIAR"
};

export default repairLog;
